export default __webpack_public_path__ + "static/media/22M.af513d31.jpeg";